module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-romantika.2b978f95.jpg";